<div *ngIf="isWorkBook && notesDataFromAPI=='false'" class="no-data-found">
  <img src="./assets/images/ui-uplift-icons/global/empty-component-search-icon.svg" alt="Icon">
  <h6>No Notes Added</h6>
  <p>To view the preview of notes, click the ‘Add Notes’ button to get started.</p>
</div>
<div *ngIf="isWorkBook" id="notes-preview" appSpin [spinnerConfig]="spinnerConfig()" style="
        width: 100%;
        margin: 0px auto;
        padding-bottom: 0px;
        font-family :Arial, sans-serif;
        padding: 10px 8px;">
</div>
<div class="page A4 my-3 workbook-preview" *ngIf="!isWorkBook" id="notes-preview" appSpin [spinnerConfig]="spinnerConfig()" style="border-radius: 5px;
    border: 1px solid #D9D9D9;
    margin: 0px auto;
    padding-bottom: 0px;
    font-family :Arial, sans-serif;
    background-size:contain;
    background-position: center;
    background-repeat: no-repeat;
    overflow: hidden;
    height: auto !important;
  min-height: 100% !important;
    "></div>